import type { ProvisionInput } from './api';

/**
 * What the server will refuse when a company is created, said before the button rather than after
 * it — "never offer a write the server will reject". The username rule is `LoginIdentifier`'s: one
 * sign-in field accepts a username or a mobile number, which is only safe because a username never
 * begins with a digit.
 */
export function provisionProblems(input: ProvisionInput): string[] {
  const problems: string[] = [];
  if (!input.code.trim())
    problems.push('A company code — what staff type on the first sign-in screen.');
  if (!input.name.trim()) problems.push('A company name.');
  if (!input.ownerUsername.trim()) problems.push("The owner's username.");
  else if (/^\d/.test(input.ownerUsername.trim()))
    problems.push('A username may not begin with a digit.');
  if (!input.ownerFullName.trim()) problems.push("The owner's name.");
  if (input.ownerMobile.replace(/\D/g, '').length < 10)
    problems.push("The owner's 10-digit mobile number.");
  if (!input.planCode) problems.push('A package.');
  return problems;
}
